import React from 'react';
import { createBrowserHistory } from 'history';
import { Route, Switch } from 'react-router-dom';
import NotificationSystem from 'react-notification-system';
import { RightSidePanel, FlexContainer, ContentWrapper } from '@atlaskit/right-side-panel';


import LeftSidebar from 'components/LeftSidebar';
import FileUploader from 'components/FileUploader'
import FilePreview from 'components/FilePreview'
import FileDownloader from 'components/FileDownloader'
import Modals from 'components/Modals'
import RenameObject from 'components/Modals/RenameObject'
import SearchInputView from 'components/SearchInput/index.jsx';

import NoMatchView from 'views/NoMatchView';

import { withPreview, withLoader } from 'HOC';

import { routes, renderSidebar } from 'routes';


const SidebarComponent = () => (
  <Switch>
    {routes.map((route, index) => (
      <Route
        key={index}
        path={route.path}
        exact={route.exact}
        replace
        render={route.sidebar}
      />
    ))}

    <Route exact component={renderSidebar()}/>

  </Switch>
)

class ParentComponent extends React.Component {
  _addNotification = (notification) => {
    this._notificationSystem.addNotification(notification);
  }

  _removeNotification = (uid) => {
    this._notificationSystem.removeNotification(uid);
  }

  render() {
    const props = Object.assign(
      { ...this.props }, 
      {
        addNotification: this._addNotification,
        removeNotification: this._removeNotification
      }
    );

    return (
      <div style={{ display: "flex"}}>
        <div
          style={{
            width: "100%",
            background: "white",
            position: 'relative' 
          }}
        >
          <LeftSidebar
            navComponent={<SidebarComponent />}
          > 
            <FlexContainer
              id='home-container'
            >
              <div
                style={
                  {
                    backgroundColor: 'white',
                    position: 'relative',
                    overflow: 'scroll',
                    width: '100%',
                    height: '100%',
                    padding: '0 15px 0 15px'
                  }
                }
              >
                <SearchInputView {...this.props}/>
                <div
                  style={{
                    overflowY: 'scroll',
                    overflowX: 'hidden',
                  }}
                >
                  <Switch>
                    {routes.map((route, index) => (
                      // Render more <Route>s with the same paths as
                      // above, but different components this time.
                      <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        replace
                        render={route.main(props)}
                      />
                    ))}

                    <Route exact component={NoMatchView}/>
                  </Switch>
                </div>
              </div>
              <FilePreview />
            </FlexContainer>
            
          </LeftSidebar>
        </div>

        <FileUploader {...props}/>

        <FileDownloader {...props }/>

        <Modals {...props}/>

        <NotificationSystem ref={ref => this._notificationSystem = ref} />
      </div>
    )
  }
};

export default ParentComponent;
